import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {

  @Input() iconName: string;
  @Input() text: string;
  @Input() color: string;
  @Input() small: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
